import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const WorksAtIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 29) / 32}
      viewBox="0 0 29 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.68164 17.9516H12.4863V16.3906H4.68164V17.9516Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.68164 24.1957H12.4863V22.6348H4.68164V24.1957Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.68164 11.7074H12.4863V10.1465H4.68164V11.7074Z"
        fill="currentColor"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M20.293 0V5.46333H21.8539V0H20.293Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6113 1.5625V5.46488H17.1723V1.5625H15.6113Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.90234 5.46407C3.90234 5.03303 4.25177 4.68359 4.68281 4.68359H23.414C23.8449 4.68359 24.1944 5.03303 24.1944 5.46407V31.2198C24.1944 31.6507 23.8449 32.0002 23.414 32.0002H4.68281C4.25177 32.0002 3.90234 31.6507 3.90234 31.2198V5.46407ZM5.46327 6.24454V30.4393H22.6335V6.24454H5.46327Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3887 17.9516H20.291V16.3906H16.3887V17.9516Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3887 24.1957H20.291V22.6348H16.3887V24.1957Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3887 11.7074H20.291V10.1465H16.3887V11.7074Z"
        fill="currentColor"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 30.4375H28.0967V31.9985H0V30.4375Z" fill="currentColor" />
    </svg>
  )
})

WorksAtIcon.displayName = 'WorksAtIcon'
